import { useEffect } from 'react';
import { getParam } from '/src/utils/location';
import { AUTH_TOKEN_KEY } from '/src/features/_global/constants';

export function StripePage() {
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
  const haveType = getParam('type');
  const billingType = haveType ? `&type=${haveType}` : '';

  useEffect(() => {
    window.location.replace(`${window.CORE_API_URL}/stripe-portal?token=${token}${billingType}`);
  }, [token, billingType]);

  return null;
}
